__turbopack_context__.v({
  "actions": "Header-module-scss-module__XrNddG__actions",
  "avatar": "Header-module-scss-module__XrNddG__avatar",
  "comingSoonLabel": "Header-module-scss-module__XrNddG__comingSoonLabel",
  "disabled": "Header-module-scss-module__XrNddG__disabled",
  "helpDesktop": "Header-module-scss-module__XrNddG__helpDesktop",
  "helpDesktopAnchor": "Header-module-scss-module__XrNddG__helpDesktopAnchor",
  "helpInvoker": "Header-module-scss-module__XrNddG__helpInvoker",
  "helpMobile": "Header-module-scss-module__XrNddG__helpMobile",
  "logo": "Header-module-scss-module__XrNddG__logo",
  "navigation": "Header-module-scss-module__XrNddG__navigation",
  "notification": "Header-module-scss-module__XrNddG__notification",
  "notificationBadge": "Header-module-scss-module__XrNddG__notificationBadge",
  "notificationBtn": "Header-module-scss-module__XrNddG__notificationBtn",
  "profile": "Header-module-scss-module__XrNddG__profile",
  "search": "Header-module-scss-module__XrNddG__search",
  "searchSlotWrap": "Header-module-scss-module__XrNddG__searchSlotWrap",
  "searchbar": "Header-module-scss-module__XrNddG__searchbar",
  "selector": "Header-module-scss-module__XrNddG__selector",
  "topbarLeft": "Header-module-scss-module__XrNddG__topbarLeft",
  "topbarRight": "Header-module-scss-module__XrNddG__topbarRight",
  "wrapper": "Header-module-scss-module__XrNddG__wrapper",
});
